import LegalLayout from "../components/LegalLayout";
import { COMPANY_INFO } from "../constants/legalText";

export default function Company() {
  return <LegalLayout title="運営会社" text={COMPANY_INFO} />;
}
